<template>
  <div class="online-renewal-thank-you">
    <v-layout>
      <v-flex md12>
        <div class="icon">
          <IconBase><IconCheck /></IconBase>
        </div>
        <v-flex md4 offset-md4>
            <center>
                <h1>Thank you for renewing your policy with FDCA</h1><br/>
                <p v-if="policyNumber">Your new policy number is {{policyNumber}}</p>
                <p>Your insurance documents and tax invoice will be emailed to you.</p>
                <!-- <v-layout>
                    <v-flex md6 offset-md3>
                        <button class="green-button">Go to member area</button>
                    </v-flex>
                </v-layout> -->
            </center>
        </v-flex>
      </v-flex>
    </v-layout>
  </div>
</template>

<style lang="css" scoped>
.online-renewal-thank-you {
    background-color: white;
    min-height: 64vh;
}
.icon {
    border: 2px solid #0db14b;
    border-radius: 100%;
    height: 60px;
    width: 60px;
    margin: 10% auto 0 auto;
}
.icon svg {
  stroke: #0db14b;
  stroke-width: 1;
  height: 60px;
  width: 60px;
}
</style>

<script>
export default {
  props: {
    policyNumber: String
  }
}
</script>
